<template>
  <div class="view-product-google-analytics">
    <h5 class="text-semibold mb-5">API do Google Analytics</h5>

    <snow-data-table-header
      v-if="integrationList.length"
      :search="false"
      :date-picker="false"
      :filters="false"
      @add="modal = true"
      class="mb-5"
    />

    <div v-if="loading" class="text-center my-9">
      <b-spinner variant="primary" />
    </div>

    <snow-data-table v-else :data="integrationList" :columns="columns" />

    <div class="row justify-content-center" v-if="!integrationList.length">
      <div class="d-flex flex-column ">
        <h3 class="mt-4">Talvez você precise</h3>
        <div class="d-flex justify-content-center mt-3">
          <snow-button
            size="md"
            text="Adicionar API"
            icon="ph ph-plus"
            @click="modal = true"
          />
        </div>
      </div>
    </div>

    <google-analytics-modal
      v-model="modal"
      :integrationToEdit="integrationToEdit"
      @update-list="dispatch"
      @clear-edit="integrationToEdit = null"
    />
  </div>
</template>

<script>
import GoogleAnalyticsModal from "@/components/product/google-analytics/GoogleAnalyticsModal.vue";
import { TRANSLATE_FIELD_INTEGRATION_MAP } from "@/constants/fields.js";
import { get_error_msg } from "@/functions/helpers";
import { mapState } from "vuex";

export default {
  components: {
    GoogleAnalyticsModal
  },
  data() {
    return {
      modal: false,
      loading: false,
      integrationToEdit: null
    };
  },
  mounted() {
    this.$store.commit("integration/setIntegration", "google-analytics");
    this.dispatch();
  },
  computed: {
    ...mapState("integration", ["integrationList"]),
    columns() {
      return [
        {
          name: "ID da Métrica",
          field: "measurement_id"
        },
        {
          name: "Chave Secreta",
          field: "api_secret"
        },
        {
          name: "",
          type: "menu",
          options: [
            {
              label: "Editar",
              click: this.edit
            },
            {
              label: "Excluir",
              class: "text-danger",
              variant: "danger",
              dialog: {
                text: "Tem certeza que deseja excluir a API?",
                secondaryButtonText: "Não, cancelar",
                buttonText: "Sim, excluir",
                action: this.submitDelete,
                icon: "ph ph-trash"
              }
            }
          ]
        }
      ];
    }
  },
  methods: {
    dispatch() {
      this.loading = true;
      this.$store
        .dispatch("integration/getIntegration", {
          product_id: this.$route.params.id
        })
        .catch(() => {
          this.$message.error("Não foi possível carregar as contas integradas");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeStatus(item) {
      let data = { ...item, status: !item.status };
      this.$store
        .dispatch("integration/putIntegration", clearObject(data))
        .then(() => {
          this.$message.success(
            `Integração ${data.status ? "ativada" : "desativada"}`
          );
          this.dispatch();
        })
        .catch(() => {
          this.$message.error(
            "Não foi possível alterar o status da integração"
          );
        });
    },
    submitDelete(item) {
      this.$store
        .dispatch("integration/deleteIntegration", item.id)
        .then(() => {
          this.dispatch();
          this.$message.success("Integração removida");
        })
        .catch(error => {
          let msg = get_error_msg(
            error.response.data,
            TRANSLATE_FIELD_INTEGRATION_MAP,
            "Não foi possível deletar a conta integrada"
          );
          this.$message.error(msg);
        });
    },
    edit(item) {
      this.integrationToEdit = item;
      this.modal = true;
    }
  }
};
</script>
